<template>
  <v-touch
    v-on:swipeleft="changeCarousel(carousel.current + 1)"
    v-on:swiperight="changeCarousel(carousel.current - 1)"
    tag="section"
    class="content d-flex flex-colmn align-items-center justify-content-center">
    <mdb-tooltip v-if="rtcStatsInsightClient && rtcStatsInsightClient.restrictedMode != 0" material trigger="click" :options="{ placement: 'left' }">
      <span slot="tip">{{ restrictedMessage }}</span>
      <mdb-icon slot="reference" class="restricted-alert clickable text-warning" icon="exclamation-triangle" size="2x"/>
    </mdb-tooltip>
    <mdb-container fluid>
      <mdb-row>
        <mdb-col col="12" :lg="shareState == 0 ? '12' : '8'" :class="['share-container', { 'd-none': shareState == 0 }]">
          <ShareView
            :device="device"
            :viewMode="viewMode"
            :shareState="shareState"
            :shareStream="shareStream"
            :shareAudioStream="shareAudioStream"
            :useBoard="useBoard"
            @onClickExpand="toggleShareViewExpand"
            @onClearWhiteboard="onClearWhiteboard"
          />
        </mdb-col>
        <mdb-col
          col="1"
          class="d-flex justify-content-center align-items-center p-0"
        >
          <mdb-icon
            v-if="carousel.prev"
            @click.native="changeCarousel(carousel.current - 1)"
            icon="angle-left"
            size="2x"
            class="text-primary clickable"
          />
        </mdb-col>
        <mdb-col
          col="10"
          :lg="shareState == 0 ? '10' : '2'"
          :class="[
            'd-flex flex-row flex-wrap align-items-center justify-content-center align-content-center peers-container',
            { 'separate-peers-container': shareState != 0 && viewMode == 0 },
            { 'expand-separate-peers-container': shareState != 0 && viewMode == 1 }
          ]">
          <mdb-btn
            v-if="shareState != 0 && viewMode == 1"
            tag="a"
            :class="['btn-toggle-peers-container', { 'hiding' : !isDiaplayPeersView }]"
            floating
            @click.native="() => isDiaplayPeersView = !isDiaplayPeersView">
            <mdb-icon :icon="isDiaplayPeersView ? 'minus' : 'users'" />
          </mdb-btn>
          <PeerView
            v-if="isVisibleMyPeerView"
            :device="device"
            :shareState="sharerPeerId == peerId"
            :speakerState="activeSpeakerPeerId == peerId"
            :micState="myMicState"
            :micVolume="myMicVolume"
            :videoStream="myStream"
            :displayName="myDisplayName"
            :myself="true"
            :isDisplay="isDiaplayPeersView"
            @toggleMic="myMicState ? muteMic() : unmuteMic()"
          />
          <PeerView
            v-for="(id, index) in visiblePeerIds"
            :key="index"
            :device="device"
            :shareState="sharerPeerId == id"
            :speakerState="activeSpeakerPeerId == id"
            :videoStream="peers[id].videoStream"
            :audioStream="peers[id].audioStream"
            :displayName="peers[id].displayName"
            :isDisplay="isDiaplayPeersView"
            :viewMode="viewMode"
          />
        </mdb-col>
        <mdb-col
          col="1"
          class="d-flex justify-content-center align-items-center p-0"
        >
          <mdb-icon
            v-if="carousel.next"
            @click.native="changeCarousel(carousel.current + 1)"
            icon="angle-right"
            size="2x"
            class="text-primary clickable"
          />
        </mdb-col>
        <mdb-col
          col="12"
          :lg="shareState == 0 ? '12' : '4'"
          :offset-lg="shareState == 0 ? '0' : '8'"
          class="carousel-container"
        >
          <div v-if="carousel.pages > 1" class="carousel text-center">
            <!-- indicators -->
            <div>
              <mdb-btn
                v-for="page in carousel.pages"
                tag="a"
                :class="['btn-indicator', { 'current': page == carousel.current }]"
                floating
                :key="page"
                @click.native="changeCarousel(page)"
              />
            </div>
          </div>
        </mdb-col>
      </mdb-row>
    </mdb-container>
    <!-- invisibleなpeersのaudio -->
    <audio
      v-for="(id, index) in invisiblePeerIds"
      :key="index"
      :srcObject.prop="peers[id].audioStream"
      autoplay
    />
    <mdb-tooltip
      v-if="viewMode == 0 && !isEnableChatView"
      trigger="hover"
      :options="{ placement: 'right' }"
      material
    >
      <span v-if="!device.isMobile" slot="tip">会議室情報</span>
      <mdb-btn
        slot="reference"
        tag="a"
        class="btn-peers-list"
        floating
        @click.native="() => peersListModal = !peersListModal">
        <mdb-icon icon="info" />
      </mdb-btn>
    </mdb-tooltip>
    <custom-mdb-btn-fixed
      v-if="viewMode == 0"
      color="primary"
      icon="ellipsis-v"
      class="btn-room-tools"
      :bottom="10"
      :right="10"
      :enableToolTip="!device.isMobile && !showToolItems"
      @click.native="showToolItems = !showToolItems"
    >
      <mdb-tooltip
        v-show="showToolItems"
        trigger="hover"
        :options="{ placement: 'left' }"
        material
      >
        <span v-if="!device.isMobile" slot="tip">退室</span>
        <mdb-btn-fixed-item
          slot="reference"
          :show="showToolItems"
          color="red"
          icon="sign-out-alt"
          @click.native.stop="confirmExitRoomModal = true"
        />
      </mdb-tooltip>
      <mdb-tooltip
        v-show="showToolItems"
        trigger="hover"
        :options="{ placement: 'left' }"
        material
      >
        <span v-if="!device.isMobile" slot="tip">会議室ロック</span>
        <mdb-btn-fixed-item
          slot="reference"
          :show="showToolItems"
          :color="locked ? 'success' : 'light'"
          :icon="locked ? 'lock' : 'unlock'"
          @click.native.stop="setRoomPasswordModal = true"
        />
      </mdb-tooltip>
      <mdb-tooltip
        v-if="shareState != 2 && device.isSupportedShare"
        v-show="showToolItems"
        trigger="hover"
        :options="{ placement: 'left' }"
        material
      >
        <span v-if="!device.isMobile" slot="tip">画面共有</span>
        <mdb-btn-fixed-item
          slot="reference"
          :show="showToolItems"
          :color="shareState == 1 ? 'default' : 'light'"
          icon="desktop"
          @click.native.stop="shareState == 1 ? disableShare() : enableShare()"
        />
      </mdb-tooltip>
      <mdb-tooltip
        v-if="useNote"
        v-show="showToolItems"
        trigger="hover"
        :options="{ placement: 'left' }"
        material
      >
        <span v-if="!device.isMobile" slot="tip">議事録{{ noteModal ? '非表示' : '表示' }}</span>
        <mdb-btn-fixed-item
          slot="reference"
          :show="showToolItems"
          :color="noteModal ? 'blue' : 'light'"
          icon="file-signature"
          @click.native.stop="noteModal = !noteModal"
        />
      </mdb-tooltip>
      <mdb-tooltip
        v-show="showToolItems"
        trigger="hover"
        :options="{ placement: 'left' }"
        material
      >
        <span v-if="!device.isMobile" slot="tip">マイク{{ myMicState ? 'オフ' : 'オン' }}</span>
        <mdb-btn-fixed-item
          slot="reference"
          :show="showToolItems"
          :color="myMicState ? 'cyan' : 'light'"
          :icon="myMicState ? 'microphone' : 'microphone-slash'"
          @click.native.stop="myMicState ? muteMic() : unmuteMic()"
        />
      </mdb-tooltip>
      <mdb-tooltip
        v-if="rtcStatsInsightClient && rtcStatsInsightClient.restrictedMode == 0"
        v-show="showToolItems"
        trigger="hover"
        :options="{ placement: 'left' }"
        material
      >
        <span v-if="!device.isMobile" slot="tip">ビデオ{{ myWebcamState ? 'オフ' : 'オン' }}</span>
        <mdb-btn-fixed-item
          slot="reference"
          :show="showToolItems"
          :color="myWebcamState ? 'teal' : 'light'"
          :icon="myWebcamState ? 'video' : 'video-slash'"
          @click.native.stop="myWebcamState ? disableWebcam() : enableWebcam()"
        />
      </mdb-tooltip>
      <mdb-tooltip
        v-else-if="rtcStatsInsightClient && rtcStatsInsightClient.enableResetRistriction"
        v-show="showToolItems"
        trigger="hover"
        :options="{ placement: 'left' }"
        material
      >
        <span v-if="!device.isMobile" slot="tip">制限モード解除</span>
        <mdb-btn-fixed-item
          slot="reference"
          :show="showToolItems"
          color="warning"
          icon="exclamation"
          @click.native.stop="resetRestrictionModal = true"
        />
      </mdb-tooltip>
    </custom-mdb-btn-fixed>
    <ChatView
      ref="chatView"
      :device="device"
      :active="isEnableChatView"
      :newArrival="newArrivalChatMessage"
      :chatMessages="chatMessages"
      @onclickChatViewButton="toggleChatView"
      @onclickSubmitChatMessage="submitChatMessage"
      @onclickDownloadChatMessages="downloadChatMessages"
    />
    <Modal
      :modal="invalidRoomNameModal"
      :disableCancelButton="true"
      title="この部屋名は利用できません"
      body="半角英数字、_(アンダーバー)、-(ハイフン)のみを使用し12文字以上で部屋名を設定してください"
      @close="closeInvalidRoomNameModal"
      @accept="closeInvalidRoomNameModal"
    />
    <Modal
      :modal="notAllowedCreateRoomModal"
      :disableCancelButton="true"
      title="この会議室には入室できません"
      @close="exitRoom(true)"
      @accept="exitRoom(true)"
    >
      <p>この会議室には、アカウント登録済みのユーザーが入室していません。</p>
      <p>アカウント登録を行うか、登録済みのユーザーに先に入室してもらう必要があります。</p>
    </Modal>
    <Modal
      :modal="reservedRoomModal"
      :disableCancelButton="true"
      title="この会議室名は使用できません"
      @close="exitRoom(true)"
      @accept="exitRoom(true)"
    >
      <p>会議室名"{{ roomName }}"は別のユーザによって専用会議室名として予約されています。</p>
    </Modal>
    <Modal
      :modal="notAllowedMultipleCreateRoomModal"
      :disableCancelButton="true"
      title="このアカウントは既に別の会議室を作成しています"
      @close="exitRoom"
      @accept="exitRoom"
    >
      <p>1つのアカウントで複数の会議室を同時に作成することはできません。</p>
    </Modal>
    <Modal
      :modal="capacityOverModal"
      :disableCancelButton="true"
      title="この会議室には入室できません"
      @close="exitRoom"
      @accept="exitRoom"
    >
      <p>この会議室は、既に定員（{{ this.roomCapacity }}名）に達しています。</p>
    </Modal>
    <Modal
      :modal="authApiFailedModal"
      :disableCancelButton="true"
      title="認証サーバとの接続に失敗しました"
      @close="exitRoom"
      @accept="exitRoom"
    >
      <p>時間をおいてから再度お試しください。</p>
    </Modal>
    <Modal
      :modal="protooFailedModal"
      :disableCancelButton="true"
      title="会議サーバとの接続に失敗しました"
      @close="exitRoom"
      @accept="exitRoom"
    >
      <p>通信帯域に問題があるか、会議サーバの会議室上限に達している可能性があります。</p>
    </Modal>
    <Modal
      :modal="resetRestrictionModal"
      title="制限モードを解除しますか？"
      @close="resetRestrictionModal = false"
      @accept="acceptResetRestriction"
    >
      <p>通信帯域に問題がある場合は、解除後に再度、制限モードに変更される可能性があります。</p>
    </Modal>
    <Modal
      :modal="joinRoomIntroductionModal"
      :disableHeader="true"
      :disableCancelButton="true"
      body="表示名設定"
      @accept="configuredJoinRoom"
    >
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i class="fas fa-user prefix"></i>
          </span>
        </div>
        <input type="text" class="form-control" v-model="myDisplayName" placeholder="Unknown">
      </div>
      <div class="text-center py-3">
        <mdb-input
          id="rememberMyDisplayName"
          type="checkbox"
          label="表示名を保存する"
          v-model="rememberMyDisplayName"/>
      </div>
      <div class="pt-3 border-top">
        <p class="font-weight-bold">
          入室時設定
          <mdb-icon class="mx-1" :icon="defaultEnableMic ? 'microphone' : 'microphone-slash'"/>
          <mdb-icon class="mx-1" :icon="defaultEnableWebcam ? 'video' : 'video-slash'"/>
        </p>
        <mdb-form-inline>
          <mdb-input
            id="defaultEnableMic"
            type="checkbox"
            label="マイクオン"
            v-model="defaultEnableMic"/>
          <mdb-input
            id="defaultEnableWebcam"
            type="checkbox"
            label="カメラオン"
            v-model="defaultEnableWebcam"/>
        </mdb-form-inline>
      </div>
    </Modal>
    <Modal
      :modal="setRoomPasswordModal"
      title="入室パスワード設定"
      @close="closeSetRoomPasswordModal"
      @accept="setRoomPassword"
    >
      <div v-if="locked" class="form-group">
        <label>現在のパスワード</label>
        <input type="password" class="form-control" v-model="currentRoomPassword">
        <small v-if="invalidCurrentPassword" class="text-danger">現在のパスワードの検証に失敗しました</small>
      </div>
      <div class="form-group">
        <label>新しいパスワード</label>
        <input type="password" class="form-control" v-model="newRoomPassword">
        <small v-if="locked" class="text-muted">パスワードロックを解除する場合は何も入力せずに送信して下さい</small>
      </div>
    </Modal>
    <Modal
      :modal="passwordVerificationModal"
      :disableHeader="true"
      :disableCancelButton="true"
      body="入室パスワードを入力して下さい"
      @accept="enterRoom"
    >
      <div class="form-group">
        <label>パスワード</label>
        <input type="password" class="form-control" v-model="verificationPassword">
        <small v-if="invalidPassword" class="text-danger">パスワード検証に失敗しました</small>
      </div>
    </Modal>
    <Modal
      :modal="confirmExitRoomModal"
      title="確認"
      body="本当に退室しますか？"
      @close="confirmExitRoomModal = false; requireDownloadNoteData = false;"
      @accept="exitRoom"
    >
      <div v-if="useNote && noteText" class="py-3 text-center">
        <custom-mdb-input
          v-model="requireDownloadNoteData"
          type="checkbox"
          id="requireDownloadNoteData"
          label="議事録データをテキスト形式でダウンロードする"
        />
      </div>
    </Modal>
    <Modal
      :modal="peersListModal"
      :scrollable="true"
      :disableCancelButton="true"
      :disableOkButton="true"
      size="lg"
      title="会議室情報"
      @close="peersListModal = false"
    >
      <mdb-tbl class="pb-2" bordered>
        <mdb-tbl-body>
          <tr>
            <th class="font-weight-bold">招待URL</th>
            <td>
              {{ inviteURL }}
              <mdb-tooltip
                trigger="hover"
                :options="{ placement: 'top' }"
                material
                sm
              >
               <span v-if="!device.isMobile" slot="tip">コピー</span>
                <mdb-icon slot="reference" far icon="copy" class="ml-4 clickable" @click.native="copyInviteURL" />
              </mdb-tooltip>
              <mdb-tooltip
                trigger="hover"
                :options="{ placement: 'top' }"
                material
                sm
              >
               <span v-if="!device.isMobile" slot="tip">メール作成</span>
                <mdb-icon slot="reference" far icon="envelope" class="ml-4 clickable" @click.native="mailtoInviteURL" />
              </mdb-tooltip>
            </td>
          </tr>
          <tr>
            <th class="font-weight-bold">参加者数</th>
            <td>{{ Object.keys(peers).length + 1 }}人</td>
          </tr>
          <tr>
            <th class="font-weight-bold">参加可能人数</th>
            <td>{{ roomCapacity }}人</td>
          </tr>
          <tr v-if="closeTime">
            <th class="font-weight-bold">終了時刻</th>
            <td>{{ closeTime }}</td>
          </tr>
        </mdb-tbl-body>
      </mdb-tbl>
      <mdb-container fluid>
        <mdb-row
          v-for="page in carousel.pages"
          :class="['rounded py-2 mb-2 z-depth-1', { 'clickable': currentCarousel != page }]"
          :key="page"
          @click.native="changeCarouselByPeersListModal(page)">
          <mdb-col col="12">
            <div v-if="page == 1" class="py-2">
              <span :class="['text-break', { 'animated flash slower infinite': activeSpeakerPeerId == peerId }]">{{ myDisplayName }}</span>
              <mdb-icon class="mx-1" :icon="myMicState ? 'microphone' : 'microphone-slash'"/>
              <mdb-icon class="mx-1" :icon="myWebcamState ? 'video' : 'video-slash'"/>
              <mdb-icon v-if="sharerPeerId == peerId" class="mx-1" icon="desktop"/>
            </div>
            <div v-for="(id, index) in peerIdsByPage(page)" :key="index" class="py-2">
              <span :class="['text-break', { 'animated flash slower infinite': activeSpeakerPeerId == id }]">{{ peers[id].displayName }}</span>
              <mdb-icon class="mx-1" :icon="peers[id].audioStream ? 'microphone' : 'microphone-slash'"/>
              <mdb-icon class="mx-1" :icon="peers[id].videoStream ? 'video' : 'video-slash'"/>
              <mdb-icon v-if="sharerPeerId == id" class="mx-1" icon="desktop"/>
            </div>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </Modal>
    <note-modal
      :modal="noteModal"
      :device="device"
      :initialized="initializedNote"
      @onClickSendNoteText="sendNoteMessage"
      @onClickCloseNoteModal="noteModal = false"
    />
  </v-touch>
</template>

<script>

// libraries
import store from '@/store'
import { mapGetters, mapMutations } from 'vuex'
import vueCookie from 'vue-cookie'

// components
import ShareView from '@/components/organisms/ShareView'
import NoteModal from '@/components/organisms/NoteModal'
import Modal from '@/components/molecules/Modal'
import PeerView from '@/components/molecules/PeerView'
import ChatView from '@/components/molecules/ChatView'

// lib
import {
  VIDEO_CONSTRAINS,
  PC_PROPRIETARY_CONSTRAINTS,
  WEBCAM_SIMULCAST_ENCODINGS,
  WEBCAM_KSVC_ENCODINGS
} from '@/lib/mediasoupConstants'
import deviceInfo from '@/lib/deviceInfo'
import randomString from 'random-string'
import urlFactory from '@/lib/urlFactory'
import { dateToString } from '@/lib/helper'

import RTCStatsInsightClient from '@/lib/RTCStatsInsightClient'
import protooClient from 'protoo-client'
import * as mediasoupClient from 'mediasoup-client'
import hark from 'hark'

export default {
  name: 'Room',
  components: {
    Modal,
    NoteModal,
    PeerView,
    ShareView,
    ChatView
  },
  data() {
    return {
      showToolItems: false,
      // 0: 共有なし, 1: 自身が共有, 2: 他人が共有
      shareState: 0,
      // 0: 通常, 1: 全画面共有
      viewMode: 0,
      isEnableChatView: false,
      isDiaplayPeersView: true,
      noteModal: false,
      invalidRoomNameModal: false,
      confirmExitRoomModal: false,
      setRoomPasswordModal: false,
      joinRoomIntroductionModal: false,
      passwordVerificationModal: false,
      peersListModal: false,
      notAllowedCreateRoomModal: false,
      reservedRoomModal: false,
      notAllowedMultipleCreateRoomModal: false,
      capacityOverModal: false,
      authApiFailedModal: false,
      protooFailedModal: false,
      resetRestrictionModal: false,
      closed: false,
      locked: false,
      sharerPeerId: null,
      activeSpeakerPeerId: null,
      myDisplayName: '',
      myMicVolume: 0,
      rememberMyDisplayName: false,
      defaultEnableWebcam: true,
      defaultEnableMic: true,
      myMicStream: null,
      myStream: null,
      shareStream: null,
      shareAudioStream: null,
      myWebcamState: false,
      myMicState: false,
      protoo: null,
      mediasoupDevice: null,
      sendTransport: null,
      recvTransport: null,
      rtcStatsInsightClient: null,
      hark: null,
      micProducer: null,
      webcamProducer: null,
      shareProducer: null,
      shareAudioProducer: null,
      chatDataProducer: null,
      whiteboardDataProducer: null,
      noteDataProducer: null,
      peers: {},
      // peers: Array.from({length: 24}, (v, k) => k).reduce((result, current, index) => {
      //   result[index] = {
      //     displayName: `peer${current}`
      //   }
      //   return result
      // }, {}),
      chatMessages: [],
      consumers: new Map(),
      dataConsumers: new Map(),
      webcams: new Map(),
      webcam: {
        device: null,
        resolution: 'hd'
      },
      currentRoomPassword: '',
      newRoomPassword: '',
      verificationPassword: '',
      invalidPassword: false,
      invalidCurrentPassword: false,
      newArrivalChatMessage: false,
      currentCarousel: 1,
      closeTime: '',
      roomCapacity: 0,
      useBoard: false,
      useNote: false,
      initializedNote: false,
      requireDownloadNoteData: false
    }
  },
  computed: {
    peerId: () => randomString({ length: 8 }).toLowerCase(),
    roomName: function() { return this.$route.params.roomName },
    inviteURL: function() { return process.env.VUE_APP_URL + this.roomName },
    device: () => deviceInfo(),
    protooUrl: function() { return urlFactory(this.roomName, this.peerId) },
    restrictedMessage: function() {
      let message
      switch (this.rtcStatsInsightClient.restrictedMode) {
        case 1: {
          message = '通信帯域が減少している為、映像送信を制限しています。'
          break
        }
        case 2:
        case 3: {
          message = '通信帯域が減少している為、映像送受信を制限しています。'
          break
        }
      }
      return message
    },
    isVisibleMyPeerView: function() {
      if (this.currentCarousel != 1) return false

      let isVisible
      switch (this.shareState) {
        case 0:
        case 1: {
          isVisible = true
          break
        }
        case 2: {
          if (this.viewMode == 0) {
            isVisible = true
          } else {
            isVisible = !this.activeSpeakerPeerId ||
                        this.activeSpeakerPeerId == this.peerId ||
                        this.activeSpeakerPeerId == this.sharerPeerId
          }
          break
        }
      }
      return isVisible
    },
    sortedPeerIds: function() {
      return Object.entries(this.peers).sort((current, next) => {
        return Number(next[0] == this.sharerPeerId) - Number(current[0] == this.sharerPeerId)
      }).map(peer => peer[0])
    },
    visiblePeerIds: function() {
      return this.peerIdsByPage(this.carousel.current)
    },
    invisiblePeerIds: function() {
      return Object.keys(this.peers).filter((peerId) => {
        return !this.visiblePeerIds.includes(peerId)
      })
    },
    peerIdsByPage: function() {
      return function(page) {
        const minIndex = this.carousel.perPage * page - this.carousel.perPage - (page == 1 ? 0 : 1)
        const maxIndex = this.carousel.perPage * page - 2
        return this.sortedPeerIds.filter((peerId, index) => {
          return minIndex <= index && index <= maxIndex
        })
      }
    },
    carousel: function() {
      const count = Object.keys(this.peers).length + 1
      let perPage
      if (this.device.isMobile) {
        switch (this.shareState) {
          case 0:
          case 1: {
            perPage = 2
            break
          }
          case 2: {
            if (this.viewMode == 0) {
              perPage = 2
            } else {
              perPage = !this.activeSpeakerPeerId
                        || this.activeSpeakerPeerId == this.peerId
                        || this.activeSpeakerPeerId == this.sharerPeerId
                        ? 2 : 3
            }
            break
          }
        }
      } else {
        switch (this.shareState) {
          case 0: {
            perPage = 8
            break
          }
          case 1: {
            perPage = this.viewMode == 0 ? 4 : 2
            break
          }
          case 2: {
            if (this.viewMode == 0) {
              perPage = 4
            } else {
              perPage = !this.activeSpeakerPeerId
                        || this.activeSpeakerPeerId == this.peerId
                        || this.activeSpeakerPeerId == this.sharerPeerId
                        ? 2 : 3
            }
            break
          }
        }
      }
      const pages = Math.ceil(count / perPage)
      return {
        prev: this.currentCarousel != 1,
        next: this.currentCarousel != pages,
        current: this.currentCarousel,
        perPage: perPage,
        pages: pages,
        count: count
      }
    },
    ...mapGetters({
      user: 'auth/user',
      signedIn: 'auth/signedIn',
      sendWhiteboardData: 'whiteboard/sendData',
      noteText: 'note/text'
    })
  },
  created: function() {

    if (this.roomName.match(/^[a-zA-Z0-9-_]{12,}$/) === null) {
      this.invalidRoomNameModal = true
      return
    }

    window.addEventListener('keydown', this.keydownOnWindow)
    window.addEventListener('beforeunload', this.beforeunloadOnWindow)

    const decide = () => {
      if (localStorage.myDisplayName) {
        this.myDisplayName = localStorage.myDisplayName
        this.rememberMyDisplayName = true
      } else if (this.user) {
        this.myDisplayName = this.user.name
        this.rememberMyDisplayName = true
      }
      this.joinRoomIntroductionModal = true
    }
    if (store.getters['auth/initialized']) {
      decide()
    } else {
      const unwatch = store.watch((state, getters) => getters['auth/initialized'], () => {
        unwatch()
        decide()
      })
    }
  },
  beforeDestroy: function() {
    window.removeEventListener('keydown', this.keydownOnWindow)
    window.removeEventListener('beforeunload', this.beforeunloadOnWindow)
    this.close()
  },
  watch: {
    viewMode: function(val) {
      if (val == 0) {
        this.isDiaplayPeersView = true
      }
      if (this.currentCarousel == 1) {
        this.controlConsumers()
      } else {
        this.currentCarousel = 1
      }
    },
    shareState: function(val) {
      if ((val == 0 && this.viewMode != 0) || val != 0) {
        this.viewMode = val == 0 ? 0 : 1
      } else {
        if (this.currentCarousel == 1) {
          this.controlConsumers()
        } else {
          this.currentCarousel = 1
        }
      }
    },
    currentCarousel: function() {
      this.controlConsumers()
    },
    peers: function() {
      // NOTE: peersの変更でcurrentCarouselに不整合が発生した場合は調整
      if (this.currentCarousel > this.carousel.pages) {
        this.changeCarousel(this.carousel.pages)
      }
      this.controlConsumers()
    },
    sendWhiteboardData: function(data) {
      this.sendWhiteboardMessage(data)
    }
  },
  methods: {
    keydownOnWindow: function(e) {
      if (e.ctrlKey && e.keyCode == 13) {
        this.$refs.chatView.onKeyBindSubmitChatMessage()
        return
      }

      if (e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLInputElement) return

      if (e.ctrlKey && e.keyCode == 77) {
        if (this.myMicState) {
          this.muteMic()
        } else {
          this.unmuteMic()
        }
        e.preventDefault()
        return
      }

      switch (e.key) {
        case 'ArrowLeft': {
          this.changeCarousel(this.currentCarousel - 1)
          break
        }
        case 'ArrowRight': {
          this.changeCarousel(this.currentCarousel + 1)
          break
        }
      }
    },
    acceptResetRestriction: function() {
      this.rtcStatsInsightClient.changeRestrictedMode(0)
      this.enableWebcam()
      this.controlConsumers()
      this.resetRestrictionModal = false
    },
    beforeunloadOnWindow: function(e) {
      e.preventDefault()
      e.returnValue = '本当に退室しますか？'
    },
    controlConsumers: function() {
      if (this.rtcStatsInsightClient.restrictedMode < 2) {
        for(const consumer of this.consumers.values()) {
          if (consumer.kind === 'audio' || consumer.appData.share || !this.peers[consumer.appData.peerId]) continue
          if (this.visiblePeerIds.includes(consumer.appData.peerId)) {
            this.resumeConsumer(consumer)
          } else {
            this.pauseConsumer(consumer)
          }
        }
      }
    },
    copyInviteURL: function() {
      navigator.clipboard.writeText(this.inviteURL).then(() => {
        this.$notify.success({
          message: 'クリップボードに招待URLをコピーしました。',
          position: 'top right',
          timeOut: 1500
        })
      }).catch(e => {
        console.error(e)
      })
    },
    mailtoInviteURL: function() {
      window.open(`mailto:?subject=【Waaarp会議招待】&body=%0D%0AWeb会議システム「Waaarp」のアクセス先は、以下となります。%0D%0A${this.inviteURL}%0D%0A`)
    },
    downloadChatMessages: function() {
      const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
      const plainMessages = [
        `会議室名: ${this.roomName}`,
        `ダウンロード日時: ${dateToString({ type: 1 })}\n`,
        '【参加者】',
        this.myDisplayName,
        ...Object.keys(this.peers).map((peerId) => {
          return this.peers[peerId].displayName
        }),
        '\n【チャット履歴】',
        ...this.chatMessages.map((message) => {
          return `(${message.date}) ${message.displayName}: ${message.text}`
        })
      ].join('\n')
      const blob = new Blob([bom, plainMessages], { type: 'application/octet-stream' })
      const virtualLink = document.createElement('a')
      virtualLink.href = URL.createObjectURL(blob)
      virtualLink.download = `${dateToString({ type: 0 })}-${this.roomName}.txt`
      virtualLink.click()
    },
    async pauseConsumer(consumer) {
      if (!consumer || consumer.paused) return
      try {
        await this.protoo.request('pauseConsumer', { consumerId: consumer.id })
        consumer.pause()
      } catch (e) {
        console.error(`pauseConsumer | failed:${e}`)
      }
    },
    async resumeConsumer(consumer) {
      if (!consumer || !consumer.paused) return
      try {
        await this.protoo.request('resumeConsumer', { consumerId: consumer.id })
        consumer.resume()
      } catch (e) {
        console.error(`resumeConsumer | failed:${e}`)
      }
    },
    closeInvalidRoomNameModal: function() {
      this.invalidRoomNameModal = false
      this.$router.push({ name: 'top' })
    },
    configuredJoinRoom: function() {
      if (this.myDisplayName && this.rememberMyDisplayName) {
        localStorage.myDisplayName = this.myDisplayName
      } else if (!this.myDisplayName) {
        this.myDisplayName = "Unknown"
      }
      this.joinRoomIntroductionModal = false
      this.join()
    },
    closeSetRoomPasswordModal: function() {
      this.currentRoomPassword = ''
      this.newRoomPassword = ''
      this.setRoomPasswordModal = false
    },
    exitRoom: function(requireAuth) {
      if (this.requireDownloadNoteData) {
        const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
        const blob = new Blob([bom, this.noteText], { type: 'application/octet-stream' })
        const virtualLink = document.createElement('a')
        virtualLink.href = URL.createObjectURL(blob)
        virtualLink.download = `${dateToString({ type: 0 })}-${this.roomName}-note.txt`
        virtualLink.click()
      }

      if (requireAuth) {
        this.$router.push({ name: 'signUp' })
      } else {
        this.$router.push({ name: 'top' })
      }
    },
    toggleShareViewExpand: function() {
      if (this.shareState === 0) return

      switch (this.viewMode) {
        case 0: {
          this.viewMode = 1
          break
        }
        case 1: {
          this.viewMode = 0
          break
        }
      }
    },
    toggleChatView: function() {
      this.isEnableChatView = !this.isEnableChatView
      this.newArrivalChatMessage = false
    },
    submitChatMessage: function(message) {
      if (!message) return
      this.sendChatMessage(message)
    },
    changeCarousel: function(page) {
      if (this.currentCarousel == page || 1 > page || this.carousel.pages < page || this.viewMode != 0) {
        return
      }
      this.currentCarousel = page
    },
    changeCarouselByPeersListModal: function(page) {
      if (this.currentCarousel != page) this.peersListModal = false
      this.changeCarousel(page)
    },
    close: function() {
      if (this.closed) return
      this.closed = true
      if (this.useWhiteboard) this.resetWhiteboardModule()
      if (this.useNote) this.resetNoteModule()
      if (this.hark) this.hark.stop()
      if (this.rtcStatsInsightClient) this.rtcStatsInsightClient.close()
      if (this.protoo) this.protoo.close()
      if (this.sendTransport) this.sendTransport.close()
      if (this.recvTransport) this.recvTransport.close()
    },
    async join() {
      const transport = new protooClient.WebSocketTransport(this.protooUrl)
      this.protoo = new protooClient.Peer(transport)

      this.protoo.on('open', () => this.checkLockStatus())

      this.protoo.on('failed', () => {
        this.protooFailedModal = true
        this.close()
      })

      this.protoo.on('disconnected', () => {
        if (this.sendTransport) {
          this.sendTransport.close()
          this.sendTransport = null
        }

        if (this.recvTransport) {
          this.recvTransport.close()
          this.recvTransport = null
        }
      })

      this.protoo.on('close', () => {
        this.close()
      })

      this.protoo.on('request', async (request, accept) => {
        switch (request.method) {
          case 'newConsumer': {
            const {
              peerId,
              producerId,
              id,
              kind,
              rtpParameters,
              // type,
              appData,
              producerPaused
            } = request.data

            let codecOptions
            if (kind === 'audio') codecOptions = { opusStereo : 1 }

            try {
              const consumer = await this.recvTransport.consume({
                id,
                producerId,
                kind,
                rtpParameters,
                codecOptions,
                appData : { ...appData, peerId }
              })

              // consumerを設定
              this.consumers.set(consumer.id, consumer)

              consumer.on('transportclose', () => {
                this.consumers.delete(consumer.id)
              })

              // NOTE: consumerの設定に使える
              // const { spatialLayers, temporalLayers } = mediasoupClient.parseScalabilityMode(
              //   consumer.rtpParameters.encodings[0].scalabilityMode
              // )

              // ここで取得したcunsumerのstreamを流し込む
              // NOTE: 他にもlayer,type,codecなどいろいろとパラメータはある

              const stream = new MediaStream
              const peer = this.peers[peerId]
              if (peer) {
                if (appData.share) {
                  stream.addTrack(consumer.track)
                  this.shareStream = stream
                  this.shareState = 2
                  this.sharerPeerId = peerId
                  this.$notify.info({
                    message: `${peer.displayName}が画面を共有しました。`,
                    position: 'top right',
                    timeOut: 1500
                  })
                } else if (appData.shareAudio) {
                  stream.addTrack(consumer.track)
                  this.shareAudioStream = stream
                } else {
                  switch (consumer.track.kind) {
                    case 'video': {
                      stream.addTrack(consumer.track)
                      peer.videoStream = stream

                      if (this.rtcStatsInsightClient.restrictedMode >= 2) {
                        peer.videoStream = null
                        consumer.close()
                        this.consumers.delete(consumer.id)
                      } else if (!this.visiblePeerIds.includes(peerId)) {
                        /**
                         * NOTE:
                         * visiblePeerIdsに該当しない場合は繋げてから強制的にpauseしておく
                         */
                        this.pauseConsumer(consumer)
                      }
                      break
                    }
                    case 'audio': {
                      if (!producerPaused) {
                        stream.addTrack(consumer.track)
                        peer.audioStream = stream
                      }
                      break
                    }
                  }
                  this.peers = Object.assign({}, this.peers, { [peerId]: peer })
                }
              }

              accept()

            } catch (e) {
              console.error(`newConsumer request | failed:${e}`)
            }
            break
          }
          case 'newDataConsumer': {
            const {
              peerId,
              dataProducerId,
              id,
              sctpStreamParameters,
              label,
              protocol,
              appData
            } = request.data

            try {
              const dataConsumer = await this.recvTransport.consumeData({
                id,
                dataProducerId,
                sctpStreamParameters,
                label,
                protocol,
                appData : { ...appData, peerId }
              })

              this.dataConsumers.set(dataConsumer.id, dataConsumer)

              dataConsumer.on('transportclose', () => {
                this.dataConsumers.delete(dataConsumer.id)
              })

              dataConsumer.on('close', () => {
                this.dataConsumers.delete(dataConsumer.id)
              })

              dataConsumer.on('message', (message) => {
                switch (dataConsumer.label) {
                  case 'chat': {
                    const peer = this.peers[peerId]
                    this.chatMessages.push({
                      displayName: peer.displayName,
                      date: JSON.parse(message).date,
                      text: JSON.parse(message).text,
                      myself: false
                    })
                    if (!this.isEnableChatView) {
                      this.newArrivalChatMessage = true
                      this.$notify.info({
                        message: `<span class="font-weight-bold">${peer.displayName}から新着メッセージ</span><div class="notify-new-chat-body">${JSON.parse(message).text}</div>`,
                        position: 'top right',
                        timeOut: 3000
                      })
                    }
                    break
                  }
                  case 'whiteboard': {
                    this.setWhiteboardReceivedData(JSON.parse(message))
                    break
                  }
                  case 'note': {

                    const plainMessage = JSON.parse(message)

                    // NOTE: $$init$$: 入室時の同期要求リクエスト
                    if (plainMessage.text != '$$init$$') {
                      const peer = this.peers[peerId]
                      if (!this.noteModal && !plainMessage.initialize) {
                        this.$notify.info({
                          message: `${peer.displayName}が議事録を更新しました。`,
                          position: 'top right',
                          timeOut: 1500
                        })
                      }
                      this.setNoteText(plainMessage.text)
                    } else if (!Object.values(this.peers).filter(peer => peer.aboriginal).length) {
                      this.sendNoteMessage(this.noteText, true)
                    }
                    break
                  }
                }
              })

              accept()
            } catch (e) {
              console.error(`recvTransport consumeData | failed:${e}`)
            }

            break
          }
        }
      })

      this.protoo.on('notification', (notification) => {
        let peer

        switch (notification.method) {
          case 'newPeer': {
            peer = notification.data
            this.$notify.info({
              message: `${peer.displayName}が入室しました。`,
              position: 'top right',
              timeOut: 1500
            })
            const newPeer = {
              [peer.id]: {
                displayName: peer.displayName
              }
            }
            this.peers = Object.assign({}, newPeer, this.peers)
            break
          }
          case 'peerClosed': {
            peer = this.peers[notification.data.peerId]
            this.$notify.warn({
              message: `${peer.displayName}が退室しました。`,
              position: 'top right',
              timeOut: 1500
            })
            this.$delete(this.peers, notification.data.peerId)
            break
          }
          case 'consumerClosed': {
            const { consumerId } = notification.data
            const consumer = this.consumers.get(consumerId)

            if (!consumer) break

            if (consumer.appData.share) {
              this.shareStream = null
              this.sharerPeerId = null
              this.shareState = 0
            } else if (consumer.appData.shareAudio) {
              this.shareAudioStream = null
            } else {
              peer = this.peers[consumer.appData.peerId]
              switch (consumer.track.kind) {
                case 'video': {
                  peer.videoStream = null
                  break
                }
                case 'audio': {
                  peer.audioStream = null
                  break
                }
              }
              this.peers = Object.assign({}, this.peers, { [consumer.appData.peerId]: peer })
            }
            consumer.close()
            this.consumers.delete(consumerId)
            break
          }
          case 'consumerPaused': {
            const { consumerId } = notification.data
            const consumer = this.consumers.get(consumerId)

            if (!consumer) break

            if (consumer.track.kind !== 'audio') return

            peer = this.peers[consumer.appData.peerId]
            peer.audioStream = null
            this.peers = Object.assign({}, this.peers, { [consumer.appData.peerId]: peer })
            break
          }
          case 'consumerResumed': {
            const { consumerId } = notification.data
            const consumer = this.consumers.get(consumerId)

            if (!consumer) break

            if (consumer.track.kind !== 'audio') return
            peer = this.peers[consumer.appData.peerId]

            const stream = new MediaStream
            stream.addTrack(consumer.track)
            peer.audioStream = stream
            this.peers = Object.assign({}, this.peers, { [consumer.appData.peerId]: peer })
            break
          }
          case 'activeSpeaker': {
            // NOTE: モバイルは負荷軽減のためアクティブスピーカ検知時の処理をなしに
            if (this.device.isMobile) break
            const { peerId } = notification.data

            // NOTE: activeSpeakerをpeersオブジェクトの先頭に移動
            if (peerId && peerId != this.peerId && !this.peerIdsByPage(1).includes(peerId)) {
              const { [peerId]: activeSpeakerPeer, ...tmpPeers } = this.peers
              this.peers = Object.assign({}, { [peerId]: activeSpeakerPeer }, tmpPeers)
            }
            this.activeSpeakerPeerId = peerId
            break
          }
          case 'changePassword': {
            const { peerId, lockStatus } = notification.data
            let message
            peer = this.peers[peerId]

            switch (lockStatus) {
              case 'Locked': {
                this.locked = true
                if (peer) {
                  message = `${peer.displayName}が入室パスワードを設定しました`
                } else {
                  message = '入室パスワードを設定しました'
                }
                break
              }
              case 'UnLocked': {
                this.locked = false
                if (peer) {
                  message = `${peer.displayName}が入室パスワードを解除しました`
                } else {
                  message = '入室パスワードを解除しました'
                }
                break
              }
            }
            this.$notify.success({
              message: message,
              position: 'top right',
              timeOut: 1500
            })
            break
          }
          case 'changeDuration': {
            // NOTE: 検証用機能
            const { closeTime } = notification.data
            this.closeTime = closeTime
            this.$notify.success({
              message: `会議終了時刻が${this.closeTime}に変更されました。(検証用機能)`,
              position: 'top right',
              timeOut: 5000
            })
            break
          }
          case 'roomStatus': {
            const { closeTime, remainTime } = notification.data
            this.closeTime = closeTime
            if ( 1 <= remainTime && remainTime <= 5) {
              this.$notify.warn({
                message: `会議終了時刻まで残り${remainTime}分です。`,
                position: 'top right',
                timeOut: 5000
              })
            } else if (remainTime == 0) {
              this.exitRoom()
            }
            break
          }


          // NOTE: 未実装のcase
          // producerScore
          // peerDisplayNameChanged
          // consumerPaused
          // consumerResumed
          // consumerLayersChanged
          // consumerScore
          // dataConsumerClosed
        }
      })
    },
    async checkLockStatus() {
      const lockStatus = await this.protoo.request('getLockStatus')
      switch (lockStatus) {
        case 'UnLocked': {
          this.enterRoom()
          break
        }
        case 'Locked': {
          this.locked = true
          this.passwordVerificationModal = true
          break
        }
      }
    },
    enterRoom: function() {
      let session = vueCookie.get('session')
      let accessToken, client, uid
      accessToken = client = uid = null
      if (session) {
        session = JSON.parse(session)
        accessToken = session['access-token']
        client = session['client']
        uid = session['uid']
      }
      this.protoo.request(
        'enterRoom',
        {
          roomPassword: this.verificationPassword,
          token: accessToken,
          client: client,
          uid: uid
        }
      ).then((res) => {
        const { roomCapacity, closeTime, useBoard, useNote } = res
        this.roomCapacity = roomCapacity
        this.useBoard = useBoard
        this.useNote = useNote
        if (closeTime) {
          this.closeTime = closeTime
          this.$notify.info({
            message: `この会議室は${closeTime}で終了します。`,
            position: 'top right',
            timeOut: 5000
          })
        }
        this.passwordVerificationModal = false
        this.joinRoom()
      }).catch((data) => {
        const { statusCode, roomCapacity } = JSON.parse(data.message)
        switch (statusCode) {
          // NOTE: 既存のBool値判定のため廃止
          // case 1: {
          //   this.notAllowedCreateRoomModal = true
          //   break
          // }
          case 2: {
            this.roomCapacity = roomCapacity
            this.capacityOverModal = true
            break
          }
          case 3: {
            this.invalidPassword = true
            break
          }
          case 11: {
            this.notAllowedCreateRoomModal = true
            break
          }
          case 12: {
            this.reservedRoomModal = true
            break
          }
          case 13: {
            this.notAllowedMultipleCreateRoomModal = true
            break
          }
          case 19: {
            this.authApiFailedModal = true
            break
          }
        }
      })
    },
    async joinRoom() {
      try {
        this.mediasoupDevice = new mediasoupClient.Device({})

        const routerRtpCapabilities = await this.protoo.request('getRouterRtpCapabilities')

        /**
         * NOTE:
         * Mac/safariでは不要だがiPadOSのPCモードの場合に判別のしようがないのでSafari一律としておく
         */
        if (this.device.flag == 'safari') {
          routerRtpCapabilities.headerExtensions =
            routerRtpCapabilities.headerExtensions.filter(
              (ext) => ext.uri !== 'urn:3gpp:video-orientation'
            )
        }

        await this.mediasoupDevice.load({ routerRtpCapabilities })

        /* ----- produce transport start ----- */
        const produceTransportInfo = await this.protoo.request(
          'createWebRtcTransport',
          {
            producing: true,
            consuming: false,
            sctpCapabilities: this.mediasoupDevice.sctpCapabilities
          }
        )

        this.sendTransport = this.mediasoupDevice.createSendTransport(
          {
            id: produceTransportInfo.id,
            iceParameters: produceTransportInfo.iceParameters,
            iceCandidates: produceTransportInfo.iceCandidates,
            iceServers: produceTransportInfo.iceServers,
            dtlsParameters: produceTransportInfo.dtlsParameters,
            sctpParameters: produceTransportInfo.sctpParameters,
            proprietaryConstraints: PC_PROPRIETARY_CONSTRAINTS
          }
        )

        this.sendTransport.on(
          'connect', ({ dtlsParameters }, callback, errback) => {
            this.protoo.request(
              'connectWebRtcTransport',
              {
                transportId : this.sendTransport.id,
                dtlsParameters
              })
              .then(callback)
              .catch(errback)
          }
        )

        this.sendTransport.on(
          'produce', async ({ kind, rtpParameters, appData }, callback, errback) => {
            try {
              const { id } = await this.protoo.request(
                'produce',
                {
                  transportId : this.sendTransport.id,
                  kind,
                  rtpParameters,
                  appData
                }
              )
              callback({ id })
            } catch (e) {
              errback(e)
            }
          }
        )

        this.sendTransport.on(
          'producedata', async ({
            sctpStreamParameters,
            label,
            protocol,
            appData
          }, callback, errback) => {
            try {
              const { id } = await this.protoo.request(
                'produceData',
                {
                  transportId: this.sendTransport.id,
                  sctpStreamParameters,
                  label,
                  protocol,
                  appData
                }
              )
              callback({ id })
            } catch (e) {
              errback(e)
            }
          }
        )

        /* ----- produce transport end ----- */

        /* ----- consume transport start ----- */
        const consumeTransportInfo = await this.protoo.request(
          'createWebRtcTransport',
          {
            producing: false,
            consuming: true,
            sctpCapabilities: this.mediasoupDevice.sctpCapabilities
          }
        )

        this.recvTransport = this.mediasoupDevice.createRecvTransport(
          {
            id: consumeTransportInfo.id,
            iceParameters: consumeTransportInfo.iceParameters,
            iceCandidates: consumeTransportInfo.iceCandidates,
            iceServers: consumeTransportInfo.iceServers,
            dtlsParameters: consumeTransportInfo.dtlsParameters,
            sctpParameters: consumeTransportInfo.sctpParameters
          }
        )

        this.recvTransport.on(
          'connect', ({ dtlsParameters }, callback, errback) => {
            this.protoo.request(
              'connectWebRtcTransport',
              {
                transportId: this.recvTransport.id,
                dtlsParameters
              })
              .then(callback)
              .catch(errback)
          }
        )

        this.rtcStatsInsightClient = new RTCStatsInsightClient(this.recvTransport)
        this.rtcStatsInsightClient.on(
          'changeRestrictedMode', (restrictedMode, event) => {
            switch (restrictedMode) {
              case 1: {
                this.disableWebcam()
                this.$notify.warn({
                  message: '通信帯域が減少している為、映像送信をOFFにしました。',
                  position: 'top right',
                  timeOut: 5000
                })
                break
              }
              case 2: {
                for(const consumer of this.consumers.values()) {
                  if (consumer.kind === 'audio' || consumer.appData.share || !this.peers[consumer.appData.peerId]) continue
                  const peer = this.peers[consumer.appData.peerId]
                  peer.videoStream = null
                  consumer.close()
                  this.consumers.delete(consumer.id)
                  this.peers = Object.assign({}, this.peers, { [consumer.appData.peerId]: peer })
                }
                this.$notify.warn({
                  message: '通信帯域が減少している為、映像受信を全てOFFにしました。',
                  position: 'top right',
                  timeOut: 5000
                })
                break
              }
            }

            if (event) {
              this.protoo.request(
                'detectRestrictMode',
                {
                  restrictLevel: restrictedMode,
                  detectEvent: event.event,
                  eventThreshold: event.threshold,
                  eventValue: event.value
                }
              )
            }
          }
        )
        this.rtcStatsInsightClient.on(
          'enabledResetRistriction', () => {
            this.$notify.info({
              message: '制限モードの解除が可能になりました。',
              position: 'top right',
              timeOut: 5000
            })
          }
        )

        /* ----- consume transport end ----- */

        /* ----- join room start ----- */
        const { peers } = await this.protoo.request(
          'join',
          {
            displayName: this.myDisplayName,
            device: this.device,
            rtpCapabilities: this.mediasoupDevice.rtpCapabilities,
            sctpCapabilities: this.mediasoupDevice.sctpCapabilities,
            roomPassword: this.verificationPassword
          }
        )

        if (!peers.length) {
          this.$notify.info({
            message: 'Waaarpでは会議室のセキュリティ向上の為、パスワードの設定を推奨しています。',
            position: 'top right',
            timeOut: 5000
          })
        }

        for (const peer of peers) {
          const newPeer = {
            [peer.id]: {
              displayName: peer.displayName,
              aboriginal: true
            }
          }
          this.peers = Object.assign({}, newPeer, this.peers)
        }

        if (this.defaultEnableMic) this.enableMic()
        if (this.defaultEnableWebcam) this.enableWebcam()
        this.enableChatDataProducer()

        if (this.useBoard) this.enableWhiteboardDataProducer()
        if (this.useNote) this.enableNoteDataProducer()

        /* ----- join room end ----- */
      } catch (e) {
        console.error(`joinRoom() | failed:${e}`)
      }
    },
    setRoomPassword: function() {
      this.protoo.request(
        'setPassword',
        {
          roomPassword: this.currentRoomPassword,
          changePassword: this.newRoomPassword
        }
      ).then(() => {
        this.invalidCurrentPassword = false
        this.closeSetRoomPasswordModal()
      }).catch(() => {
        this.invalidCurrentPassword = true
      })
    },
    async muteMic() {
      this.micProducer.pause()

      this.myMicState = false
      if (this.hark) this.hark.stop()

      try {
        await this.protoo.request('pauseProducer', { producerId: this.micProducer.id })
      } catch (e) {
        console.error(`muteMic() | failed:${e}`)
      }
    },
    async unmuteMic() {
      if (!this.micProducer) {
        this.enableMic()
        return
      }
      this.micProducer.resume()

      this.myMicState = true
      if (this.hark) this.hark.stop()
      this.hark = hark(this.myMicStream, { play: false })
      this.hark.on('volume_change', (dBs) => {
        let micVolume = Math.round(Math.pow(10, dBs / 85) * 10)
        if (micVolume === 1) {
          micVolume = 0
        }
        if (micVolume !== this.myMicVolume) {
          this.myMicVolume = micVolume
        }
      })

      try {
        await this.protoo.request('resumeProducer', { producerId: this.micProducer.id })
      } catch (e) {
        console.error(`unmuteMic() | failed:${e}`)
      }
    },
    async enableMic() {
      let track

      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
        track = stream.getAudioTracks()[0]

        this.micProducer = await this.sendTransport.produce({
          track,
          codecOptions: {
            opusStereo: 1,
            opusDtx: 1
          }
        })

        this.myMicStream = stream
        this.myMicState = true

        this.micProducer.on('transportclose', () => {
          this.micProducer = null
        })

        this.micProducer.on('trackended', () => {
          this.disableMic().catch(() => {})
        })

        if (this.hark) this.hark.stop()
        this.hark = hark(stream, { play: false })

        this.hark.on('volume_change', (dBs) => {
          let micVolume = Math.round(Math.pow(10, dBs / 85) * 10)
          if (micVolume === 1) {
            micVolume = 0
          }
          if (micVolume !== this.myMicVolume) {
            this.myMicVolume = micVolume
          }
        })

      } catch (e) {
        console.error(`enableMic() | failed:${e}`)
        if (track) {
          track.stop()
        }
      }
    },
    async disableMic() {
      this.micProducer.close()

      this.myMicState = false
      if (this.hark) this.hark.stop()

      try {
        await this.protoo.request('closeProducer', { producerId: this.micProducer.id })
      } catch (e) {
        console.error(`disableMic() | failed:${e}`)
      }
      this.micProducer = null
    },
    async enableWebcam() {
      if (this.webcamProducer) return

      let track
      let device

      try {
        await this.updateWebcams()
        device = this.webcam.device
        const { resolution } = this.webcam

        if (!device) {
          // TODO: webcamが検知できなかった場合
        }

        const stream = await navigator.mediaDevices.getUserMedia({
          video: {
            deviceId: { ideal: device.deviceId },
            frameRate: { ideal: 10, max: 30 },
            ...VIDEO_CONSTRAINS[resolution]
          }
        })

        track = stream.getVideoTracks()[0]

        const firstVideoCodec = this.mediasoupDevice.rtpCapabilities.codecs.find((c) => c.kind === 'video')

        let encodings

        if (firstVideoCodec.mimeType.toLowerCase() === 'video/vp9') {
          encodings = WEBCAM_KSVC_ENCODINGS
        } else {
          encodings = WEBCAM_SIMULCAST_ENCODINGS
        }

        this.webcamProducer = await this.sendTransport.produce({
          track,
          encodings,
          codecOptions: {
            videoGoogleStartBitrate: 1000
          }
        })

        this.myStream = stream
        this.myWebcamState = true

        this.webcamProducer.on('transportclose', () => {
          this.webcamProducer = null
        })

        this.webcamProducer.on('trackended', () => {
          this.disableWebcam().catch(() => {})
        })

      } catch (e) {
        console.error(`enableWebcam() | failed:${e}`)
        if (track) {
          track.stop()
        }
      }
    },
    async disableWebcam() {
      this.webcamProducer.close()

      this.myStream = null
      this.myWebcamState = false

      try {
        await this.protoo.request('closeProducer', { producerId: this.webcamProducer.id })
      } catch (e) {
        console.error(`disableWebcam() | failed:${e}`)
      }
      this.webcamProducer = null
    },
    async updateWebcams() {
      this.webcams = new Map()

      const devices = await navigator.mediaDevices.enumerateDevices()

      for (const device of devices) {
        if (device.kind !== 'videoinput') continue
        this.webcams.set(device.deviceId, device)
      }

      // Array.fromで配列に変換しておく
      const array = Array.from(this.webcams.values())
      const len = array.length
      const currentWebcamId = this.webcam.device ? this.webcam.device.deviceId : undefined

      if (len === 0) {
        this.webcam.device = null
      } else if (!this.webcams.has(currentWebcamId)) {
        this.webcam.device = array[0]
      }
    },
    async enableShare() {
      if (this.shareProducer) return
      let track, audioTrack

      try {
        const stream = await navigator.mediaDevices.getDisplayMedia({
          audio: true,
          video: {
            displaySurface: 'monitor',
            logicalSurface: true,
            cursor: true,
            width: { max: 1440 },
            height: { max: 810 },
            frameRate: { max: 5 }
          }
        })

        track = stream.getVideoTracks()[0]

        // NOTE: 画面共有でのSIMULCASTは現状NG

        this.shareProducer = await this.sendTransport.produce({
          track,
          codecOptions: {
            videoGoogleStartBitrate : 1000
          },
          appData: {
            share: true
          }
        })

        this.shareStream = stream
        this.shareState = 1
        this.sharerPeerId = this.peerId

        // transportclose,trackendedではローカルも反映させたほうが良い？
        this.shareProducer.on('transportclose', () => {
          this.shareProducer = null
        })

        this.shareProducer.on('trackended', () => {
          this.disableShare().catch(() => {})
        })

        audioTrack = stream.getAudioTracks()[0]
        if (audioTrack) {
          this.shareAudioProducer = await this.sendTransport.produce({
            track: audioTrack,
            codecOptions: {
              opusStereo: 1,
              opusDtx: 1
            },
            appData: {
              shareAudio: true
            }
          })

          this.shareAudioProducer.on('transportclose', () => {
            this.shareAudioProducer = null
          })
        }
      } catch (e) {
        console.error(`enableShare() | failed:${e}`)

        if (track) track.stop()
        if (audioTrack) audioTrack.stop()
      }
    },
    async disableShare() {
      if (!this.shareProducer) return

      this.shareProducer.close()

      if (this.shareAudioProducer) {
        this.shareAudioProducer.close()
      }

      this.shareStream = null
      this.shareAudioStream = null
      this.sharerPeerId = null
      this.shareState = 0

      try {
        await this.protoo.request(
          'closeProducer', { producerId: this.shareProducer.id }
        )
      } catch (e) {
        console.error(`_protoo request closeProducer() | failed:${e}`)
      }
      this.shareProducer = null
      this.shareAudioProducer = null
    },
    async enableChatDataProducer() {
      try {
        this.chatDataProducer = await this.sendTransport.produceData({
          ordered: false,
          maxRetransmits: 1,
          label: 'chat',
          priority: 'medium',
          appData: { info: 'chat-DataProducer' }
        })

        this.chatDataProducer.on('transportclose', () => {
          this.chatDataProducer = null
        })

        this.chatDataProducer.on('close', () => {
          this.chatDataProducer = null
        })
      } catch (e) {
        console.error(`enableChatDataProducer() | failed:${e}`)
      }
    },
    async enableWhiteboardDataProducer() {
      try {
        this.whiteboardDataProducer = await this.sendTransport.produceData({
          ordered: false,
          maxRetransmits: 1,
          label: 'whiteboard',
          priority: 'medium',
          appData: { info: 'whiteboard-DataProducer' }
        })

        this.whiteboardDataProducer.on('transportclose', () => {
          this.whiteboardDataProducer = null
        })

        this.whiteboardDataProducer.on('close', () => {
          this.whiteboardDataProducer = null
        })
      } catch (e) {
        console.error(`enableWhiteboardDataProducer() | failed:${e}`)
      }
    },
    async enableNoteDataProducer() {
      try {
        this.noteDataProducer = await this.sendTransport.produceData({
          ordered: false,
          maxRetransmits: 1,
          label: 'note',
          priority: 'medium',
          appData: { info: 'note-DataProducer' }
        })

        this.noteDataProducer.on('transportclose', () => {
          this.noteDataProducer = null
        })

        this.noteDataProducer.on('close', () => {
          this.noteDataProducer = null
        })

        this.noteDataProducer.on('open', () => {
          this.initializedNote = true
          this.sendNoteMessage('$$init$$')
        })

        /**
         * NOTE: onOpenがハンドリングが不安定
         * 5秒経過してもinitリクエストがいっていない場合には強制的にinitリクエスト
         */
        setTimeout(() => {
          if (!this.initializedNote) {
            this.initializedNote = true
            this.sendNoteMessage('$$init$$')
          }
        }, 5000)

      } catch (e) {
        console.error(`enableNoteDataProducer() | failed:${e}`)
      }
    },
    async sendChatMessage(message) {
      if (!this.chatDataProducer) return
      try {
        this.chatDataProducer.send(message)
        this.chatMessages.push({
          displayName: this.myDisplayName,
          date: JSON.parse(message).date,
          text: JSON.parse(message).text,
          myself: true
        })
      } catch (e) {
        console.error(`sendChatMessage() | failed:${e}`)
      }
    },
    async sendWhiteboardMessage(message) {
      if (!this.whiteboardDataProducer) return
      try {
        this.whiteboardDataProducer.send(message)
      } catch (e) {
        console.error(`sendWhiteboardMessage() | failed:${e}`)
      }
    },
    async sendNoteMessage(message, initialize = false) {
      if (!this.noteDataProducer) return
      try {
        this.noteDataProducer.send(JSON.stringify({
          text: message,
          initialize: initialize
        }))
      } catch (e) {
        console.error(`sendWhiteboardMessage() | failed:${e}`)
      }
      if (message !== '$$init$$') this.setNoteText(message)
    },
    async onClearWhiteboard() {
      if (!this.whiteboardDataProducer) return
      try {
        this.whiteboardDataProducer.send(JSON.stringify({
          action: 'clear'
        }))
      } catch (e) {
        console.error(`sendWhiteboardMessage() | failed:${e}`)
      }
    },
    ...mapMutations({
      setWhiteboardReceivedData: 'whiteboard/setReceivedData',
      setNoteText: 'note/setText',
      resetWhiteboardModule: 'whiteboard/resetModule',
      resetNoteModule: 'note/resetModule'
    })
  }
}
</script>

<style lang='scss'>
@import "@/styles/room.scss";
</style>
